import PrivacyPolicyDocument from '../../modules/legal/PrivacyPolicyDocument';

export default PrivacyPolicyDocument;
